import type { ReactElement } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/cn';

interface Props {
  className?: string;
}

// Toggle visual día/noche. Sun cuando está dark (sugiere "ir a light"), moon
// cuando está light. Pequeño, redondo, con feedback de hover.
export function ThemeToggle({ className }: Props): ReactElement {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggle}
      title={isDark ? 'Cambiar a modo diurno' : 'Cambiar a modo nocturno'}
      aria-label={isDark ? 'Activar modo claro' : 'Activar modo oscuro'}
      className={cn(
        'relative inline-flex items-center justify-center',
        'w-9 h-9 rounded-full',
        'border border-surface-border',
        'bg-surface-elevated hover:bg-surface-panel',
        'text-ink-muted hover:text-ink',
        'transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-brand-500/40',
        className,
      )}
    >
      {isDark ? (
        // Sun
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
        </svg>
      ) : (
        // Moon
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
